import NetworkRequestConfiguration from '@root/core/src/networking/network-request-configuration';

const smsAppDownloadConfiguration = ({ rootId, phoneNumber }) => {
  return new NetworkRequestConfiguration({
    endpoint: 'web_app_text_message/send_unauthenticated_app_download_link',
    method: NetworkRequestConfiguration.Methods.POST,
    bodyParameters: {
      rootId,
      phoneNumber,
    },
  });
};

export default smsAppDownloadConfiguration;
